import { render, staticRenderFns } from "./handoverPosTab.vue?vue&type=template&id=1903e014&scoped=true&"
import script from "./handoverPosTab.vue?vue&type=script&lang=js&"
export * from "./handoverPosTab.vue?vue&type=script&lang=js&"
import style0 from "./handoverPosTab.vue?vue&type=style&index=0&id=1903e014&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903e014",
  null
  
)

export default component.exports